module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAq0lEQVQ4T+2T4QnCMBBGm9wYuoHuYN3BGRIOuoN1B+HIzeAO1h10Ax3jclJoSiuSdIDmTyC5exzH90w1HCJqAeCgqnV6+3cbYzoReSBi2/+bVMTMTxFpELHLAYioBoCrc24/A4QQ1Hs/AnOQae3YsAKqat1BfgdEtEHETwpXMUh9g7X2PU1jjHGbIEXAb4wXTcDMdxG5LJTp7Jw7zmQadD6p6q6g80tEbknnL0D2oBHupDzOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/16-手机.png
// module id = 286
// module chunks = 2